import { render, staticRenderFns } from "./HuaxiannewsRotation.vue?vue&type=template&id=14ce29a1&scoped=true&"
import script from "./HuaxiannewsRotation.vue?vue&type=script&lang=js&"
export * from "./HuaxiannewsRotation.vue?vue&type=script&lang=js&"
import style0 from "./HuaxiannewsRotation.vue?vue&type=style&index=0&id=14ce29a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ce29a1",
  null
  
)

export default component.exports